import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const SearchDataSetMemberSchema = withDefaults({
  // No 'search-' prefix -- see search-index-definition.schema.ts's identical comment. Matches
  // Api::V2::Admin::DataSetMemberResource's own bare wire type ('data-set-members', normalized singular).
  type: 'data-set-member',
  fields: [
    {
      kind: 'attribute',
      name: 'embedMethod',
    },
    {
      kind: 'attribute',
      name: 'position',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'dataSet',
      type: 'data-set',
      options: {
        async: false,
        inverse: 'dataSetMembers',
      },
    },
    {
      kind: 'belongsTo',
      name: 'indexDefinition',
      type: 'index-definition',
      options: {
        async: false,
        inverse: 'dataSetMembers',
      },
    },
    {
      kind: 'hasMany',
      name: 'dataSetMemberFields',
      type: 'data-set-member-field',
      options: {
        async: false,
        inverse: 'dataSetMember',
      },
    },
  ],
});

export default SearchDataSetMemberSchema;
